import PropTypes from "prop-types";

import DeleteButton from "@/components/Header/Button/DeleteButton";
import InfoButton from "@/components/Header/Button/InfoButton";
import HeaderButtonList from "@/components/Header/HeaderButtonList/HeaderButtonList";
import { BUTTON_TYPE, BUTTON_KEYS } from "@/constants/Button";
import OrganizationEdit from "@/features/Organizations/OrganizationEdit";
import { useAuthorization } from "@/modules/authorization";
import { OrganizationInfo } from "@/modules/organization/organization-info";
import { useSidePanel } from "@/modules/side-panel";
import { EditButton } from "@/ui/edit-button";

const HeaderButtons = ({ organization = {} }) => {
  const { openSidePanel } = useSidePanel();
  const { canUpdate, canDelete } = useAuthorization();

  const onEditClick = () => {
    openSidePanel({
      title: organization.name,
      component: <OrganizationEdit organizationId={organization.id} />,
    });
  };

  const onInfoSelect = () => {
    openSidePanel({
      title: organization.name,
      component: <OrganizationInfo organization={organization} />,
    });
  };

  const primaryActions = [];
  primaryActions.push(<InfoButton key="info" onInfoSelect={onInfoSelect} />);

  const secondaryActions = [];

  if (canUpdate(organization)) {
    secondaryActions.push({
      key: BUTTON_KEYS.EDIT,
      label: (
        <EditButton key={BUTTON_KEYS.EDIT} type="text" onClick={onEditClick} />
      ),
    });
  }

  if (canDelete(organization)) {
    secondaryActions.push({
      key: BUTTON_KEYS.DELETE,
      label: (
        <DeleteButton
          key={BUTTON_KEYS.DELETE}
          modelKey="organization"
          model={organization}
          buttonProps={{
            type: BUTTON_TYPE.TEXT,
          }}
        />
      ),
    });
  }

  return (
    <HeaderButtonList
      primaryActions={primaryActions}
      secondaryActions={secondaryActions}
    />
  );
};

HeaderButtons.propTypes = {
  organization: PropTypes.object.isRequired,
};

export default HeaderButtons;
